/* eslint-disable */
import config from '../../../config'
import styles from './index.module.scss'
import { DetailsCard } from '../../../components/core/cards'
import { useLayoutEffect, useState, useContext, useEffect } from 'react'
import { PageContext } from '../../../context/PageContextProvider'
import PagesAPI from '../../../api/pages'
import Loading from '../../../components/pages/loading'

import { Swiper, SwiperSlide } from 'swiper/react'
import './style.css'
import 'swiper/css'

const Details = () => {
  const { language } = useContext(PageContext)
  const [load, setLoad] = useState(false)
  const [card1, setCard1] = useState([])
  const [card2, setCard2] = useState([])
  const [card3, setCard3] = useState([])
  useEffect(() => {
    (async () => {

    const data1 = await PagesAPI.getPersonalDevCard()
    const data2 = await PagesAPI.getBussinesCunsultingCard()
    const data3 = await PagesAPI.getJoinOurFamilyCard()
    setCard3(data3.data)
    setCard2(data2.data)
    setCard1(data1.data)
    setLoad(true)
  
    })();
  }, [language])
  const linkBuilder = (url) => {
    return config.API_URL + url
  }
  const [width, setWidth] = useState(false)
  const generateCards = () => {
    return (
      <div className={styles.content}>
        <DetailsCard
          key={1}
          img={linkBuilder(card1?.photoLocation)}
          title={card1?.title?.[language] || ''}
          description={
            language === 'AZ'
              ? card1?.description_az
              : language === 'TR'
              ? (card1?.description_tr || card1?.description_az)
              : language === 'ENG'
              ? card1?.description_eng
              : (card1?.description_ru || card1?.description_az)
          }
          to={'/services/1'}
        />
        <DetailsCard
          key={2}
          img={linkBuilder(card2?.photoLocation)}
          title={card2?.title?.[language] || ''}
          description={
            language === 'AZ'
              ? card2?.description_az
              : language === 'TR'
              ? (card2?.description_tr || card2?.description_az)
              : language === 'ENG'
              ? card2?.description_eng
              : (card2?.description_ru || card2?.description_az)
          }
          to={'/services/1'}
        />
        <DetailsCard
          key={3}
          img={linkBuilder(card3?.photoLocation)}
          title={card3?.title?.[language] || ''}
          description={
            language === 'AZ'
              ? card3?.description_az
              : language === 'TR'
              ? (card3?.description_tr || card3?.description_az)
              : language === 'ENG'
              ? card3?.description_eng
              : (card3?.description_ru || card3?.description_az)
          }
          to={'/join-our-family'}
        />
      </div>
    )
  }
  useLayoutEffect(() => {
    function updateSize() {
      if (window.innerWidth <= 768) {
        setWidth(true)
        return
      }
      setWidth(false)
    }
    window.addEventListener('resize', updateSize)
    updateSize()
  }, [])

  return load ? (
    <section className={styles.container}>
      {width ? (
        <Swiper
          slidesPerView={'auto'}
          spaceBetween={16}
          className="detail-swiper"
        >
          <SwiperSlide>
            <DetailsCard
              img={linkBuilder(card1?.photoLocation)}
              title={card1?.title?.[language] || ''}
              description={
                language === 'AZ'
                  ? card1?.description_az
              : language === 'TR'
              ? (card1?.description_tr || card1?.description_az)
              : language === 'ENG'
              ? card1?.description_eng
              : (card1?.description_ru || card1?.description_az)
              }
              to={'/services/1'}
            />
          </SwiperSlide>
          <SwiperSlide>
            <DetailsCard
              img={linkBuilder(card2?.photoLocation)}
              title={card2?.title?.[language] || ''}
              description={
                language === 'AZ'
                  ? card2?.description_az
              : language === 'TR'
              ? (card2?.description_tr || card2?.description_az)
              : language === 'ENG'
              ? card2?.description_eng
              : (card2?.description_ru || card2?.description_az)
              }
              to={'/services/1'}
            />
          </SwiperSlide>
          <SwiperSlide>
            <DetailsCard
              img={linkBuilder(card3?.photoLocation)}
              title={card3?.title?.[language] || ''}
              description={
                language === 'AZ'
                  ? card3?.description_az
              : language === 'TR'
              ? (card3?.description_tr || card3?.description_az)
              : language === 'ENG'
              ? card3?.description_eng
              : (card3?.description_ru || card3?.description_az)
              }
              to={'/join-our-family'}
            />
          </SwiperSlide>
        </Swiper>
      ) : (
        generateCards()
      )}
    </section>
  ) : (
    <Loading />
  )
}

export default Details
